<section class="image-view-container">
  <header>
    <h4>SG {{ data.sg123 ?? ''}}</h4>
    <button class="close" (click)="closeDialog()">X</button>
  </header>
  <div id="image-view" >
    <canvas id="img_canvas"></canvas>
  </div>
</section>
